import React, { ReactElement } from "react";
import { renderContentProps } from "./types";
import { NormalMessage } from "./normal-message";
import { MessageAttachments } from "../../components/message-attachments";

export const FbMessage = (props: renderContentProps): ReactElement => {
  return (
    <>
      <MessageAttachments {...props} />
      <NormalMessage {...props} />
    </>
  );
};
